import * as React from 'react';
import { DropDownListComponent } from '../DropDownList/DropDownListComponent';
import { ItemList } from '../../types/logbook-type';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { MAINTAINANCE_REQUEST_ISSUE_TYPE } from '../../app/enum/ENUM';

export interface Props {
    defaultValue: string;
    callback: (serviceType: number) => void;
}

const ServiceTypeFilterSelect: React.FunctionComponent<Props> = (props) => {

    const { defaultValue, callback } = props;
    
    const { t } = useLanguageLocale();

    const [serviceTypeListData, setServiceTypeListData] = React.useState<ItemList>([]);

    const serviceTypeList = () => {
        const data = [];
        for (const key in MAINTAINANCE_REQUEST_ISSUE_TYPE) {
            if (!isNaN(Number(key))) { 
                data.push({
                    id: key, 
                    name: t(`MAINTENANCE_DETAILS.${MAINTAINANCE_REQUEST_ISSUE_TYPE[key]}`)
                })
            }
        }
        return data;
    }

    const handleChange = (serviceType: number) => {
        callback(serviceType);
    }

    React.useEffect(() => {
        setServiceTypeListData(serviceTypeList());
    }, [])  // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <DropDownListComponent
            disabled={false}
            data-testid="asset-service-type-filter"
            list={serviceTypeListData}
            value={t('SEARCH.ALL_SERVICE_TYPES')}
            handleSelection={handleChange}
            selected={''}
            defaultSelection={defaultValue}>
        </DropDownListComponent>
    );
};

export default ServiceTypeFilterSelect;
